import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { faGaugeHigh } from "@fortawesome/free-solid-svg-icons";
import DashboardAnalytics from "../../Components/Stats/DashboardAnalytics";
import PageHeader from "../../Components/Common/PageHeader";

const Dashboard = () => {
  const { currentUser } = useAuth();

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="Operations Dashboard"
          description="A cleaner control center for live order trends, storefront performance, and daily execution."
          icon={faGaugeHigh}
          breadcrumb="Control center"
        >
          <div className="page-meta-chip">
            {currentUser?.admin ? "Administrator access" : "Team workspace"}
          </div>
        </PageHeader>

        <DashboardAnalytics />
      </div>
    </main>
  );
};

export default Dashboard;
